export default __webpack_public_path__ + "static/media/p1.6447cf7b.jpeg";